import { blackColor, whiteColor } from 'assets/styles/jss/main';

export default {
  content: {
    position: 'relative',
    zIndex: '4',
    minHeight: '100vh',
    paddingTop: 80,
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    margin: '0 auto',
  },
  title: {
    color: whiteColor,
    textShadow: '-1px 1px 5px #404040',
    textAlign: 'center',
    textTransform: 'uppercase',
    '@media screen and (max-width: 599.95px)': {
      color: blackColor,
    },
  },
  description: {
    fontSize: '18px',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  button: {
    position: 'absolute',
    bottom: 10,
    right: 0,
    left: 0,
    height: 45,
    width: 170,
    margin: 'auto',
    padding: '12px 0',
  },
};
